export function getCookieByName(name) {
  if (!document.cookie.includes(name))
    return false;

  const cookies = document.cookie.split(";")?.map(c => c.trim());
  return cookies.find(c => c.includes(name))?.split("=")[1];
}

/**
 * returns a float equal to the percentage of nAspect1 to nAspect2 of n 
 * @param {number} nAspect1 
 * @param {number} nAspect2
 * @param {number} n
 */
export function getResultingAspectFloat(nAspect1, nAspect2, n) {
  const percentage = nAspect2 * 100 / nAspect1;
  return n * percentage / 100;
}

/**
 * sets a css --w variable to the targeted nodes
 * with their offsetWidth 
 * @param {NodeList} btns
 */
export function setButtonsWidth(btns) {
  btns?.forEach((btn) => {
    btn.style.removeProperty("--w");

    const w = btn.offsetWidth;
    btn.style.setProperty("--w", `${w}px`);
  });
} 